import { Box } from '@deity/falcon-ui';
import type { ReactElement } from 'react';
import React from 'react';

type TableViewProps = {
  gridTemplateColumns: string;
};

export const TableView: React.FC<TableViewProps> = ({ children, gridTemplateColumns }) => {
  const tableItemsWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child as ReactElement<any>, { gridTemplateColumns, style: { width: '100%' } });
    }

    return child;
  });

  return <Box>{tableItemsWithProps}</Box>;
};
